import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import { SectionHeader } from '@cox/core-ui8/dist/SectionHeader'

import { ReactSectionHeaderProps } from './types'
import withAEM from '../../hoc/withAEM'
import { useInversionData } from '../../hooks/useInversionData'
import { getInversionTokenValues } from '../../utils/inversion-util'

const ReactSectionHeader = (props: ReactSectionHeaderProps): JSX.Element => {
  const { eyebrow, description, title, hideMCP = false, isInEditor = false } = props

  //Inversion Changes
  const inversionItems = useInversionData()
  const { appData } = useAppDataContext()
  const inversionTitle = getInversionTokenValues(JSON.stringify(title), inversionItems)?.match(/<p>(.*?)<\/p>/)?.[1]
  const getTitle = () => {
    return appData?.page?.isInversion === 'true' ? inversionTitle : title
  }

  const inversionDescription = getInversionTokenValues(JSON.stringify(description), inversionItems)
    ?.replace('\\r\\n', '')
    .replace(/\\/g, '')
  const getDescription = () => {
    return appData?.page?.isInversion === 'true' ? inversionDescription : description
  }

  const eyebrowObj = {
    value: eyebrow,
    isRTE: true
  }
  const descriptionObj = {
    value: getDescription(),
    isRTE: true
  }
  const titleObj = {
    value: getTitle(),
    isRTE: true
  }
  const SectionHeaderWithAEM = withAEM(SectionHeader)

  return (
    <SectionHeaderWithAEM
      {...props}
      eyebrow={eyebrow && typeof eyebrow === 'string' ? eyebrowObj : eyebrow}
      description={description && typeof description === 'string' ? descriptionObj : description}
      title={title && typeof title === 'string' ? titleObj : title}
      hideMCP={hideMCP}
      isInEditor={isInEditor}
      compName={'Section Header'}
    />
  )
}
export default ReactSectionHeader
